function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M495.305,198.055c-12.421,0-224.851,0-229.557,0c0-46.655,0.019-42.353-0.024-42.982 c-1.079-44.921-63.085-74.308-132.849-74.308C61.239,80.766,0,111.381,0,156.237v199.526c0,22.318,15.337,42.368,43.186,56.458 c24.235,12.261,56.086,19.013,89.687,19.013h81.964H312.5h97.662h85.142c9.22,0,16.695-7.475,16.695-16.695V214.751 C512,205.529,504.525,198.055,495.305,198.055z M33.41,155.953c0.401-17.551,38.157-41.796,99.464-41.796 c61.636,0,99.483,24.51,99.483,42.081c0,16.568-23.188,41.817-101.099,41.817c-63.813,0-97.867-24.339-97.867-41.819 C33.391,156.142,33.407,156.048,33.41,155.953z M478.609,397.843L478.609,397.843h-51.751V357.29 c0-9.22-7.475-16.695-16.695-16.695s-16.695,7.475-16.695,16.695v40.553h-64.272V357.29c0-9.22-7.475-16.695-16.695-16.695 s-16.695,7.475-16.695,16.695v40.553h-64.272V357.29c0-9.22-7.475-16.695-16.695-16.695s-16.695,7.475-16.695,16.695v40.553 h-65.269c-61.636,0-99.483-24.509-99.483-42.08V207.174c27.993,17.596,66.048,24.533,99.483,24.533 c0,0,345.728-0.262,345.735-0.262V397.843z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgMetrosIcon = function SvgMetrosIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMetrosIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/metros_icon.164ada48.svg";
export { ForwardRef as ReactComponent };